module.exports = __webpack_public_path__ + "static/media/comment.04d2e6b5.svg";